import React from 'react';
import { ReceiptForm } from '../receipt-form';

const UpdateReceiptForm: React.FC = () => {
  return <ReceiptForm mode="update" />;
};

export default UpdateReceiptForm;
